module.exports = __webpack_public_path__ + "media/images/posts/wedding-location-e85d9115e48bc81b90773f4fd3fefcd7.jpg";